module.exports = __webpack_public_path__ + "static/pixie-25c2431c17fe2a58fc3a913df44ac95c.jpeg";